module.exports = __webpack_public_path__ + "img/clock.e5a1dacf.svg";